import * as React from "react"

export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-page px-4 py-12 text-ink-body">
      <div className="flex w-full max-w-md flex-col items-center gap-6">
        <div className="flex items-center gap-2" aria-label="SparkDrop">
          <img src="/icon.svg" alt="" aria-hidden="true" className="h-8 w-8" />
          <span className="font-display text-lg font-semibold text-ink-display">
            SparkDrop
          </span>
        </div>
        <div className="callout w-full">{children}</div>
      </div>
    </div>
  )
}
